//接口里那城市三层选择，参数是个数组，接收返回值 数据源
export function getCityListData (receive, data) {
        let areaList = []
        for (let firstKey of data) {
                let firstObj = {
                        value: firstKey.key,
                        label: firstKey.value,
                        children: []
                }
                for (let secondKey of firstKey.children) {
                        let secondObj = {
                                value: secondKey.key,
                                label: secondKey.value,
                                children: []
                        }
                        for (let threeKey of secondKey.children) {
                                secondObj.children.push({
                                        value: threeKey.key,
                                        label: threeKey.value,
                                })
                        }
                        firstObj.children.push(secondObj)
                }
                areaList.push(firstObj)
        }
        receive.push(...areaList);
}
//下载文件流
export function dowLoadFile (data, name = '', type = 0) {
        let blob = new Blob([data], {
                type: "application/vnd.ms-excel;charset=utf-8",
        });
        if (navigator.msSaveBlob) {
                // 启用IE内置下载器下载
                try {
                        window.navigator.msSaveBlob(
                                blob,
                                type == 1 ? name : name + '_' + new Date().getTime() + ".xls"
                        );
                } catch (e) {
                        console.log(e);
                }
        } else {
                let downloadElement = document.createElement("a");
                let href = window.URL.createObjectURL(blob); //创建下载的链接
                downloadElement.href = href;
                if (name && !type) downloadElement.download = name + '_' + new Date().getTime() + ".xls"; //下载后文件名
                else downloadElement.download = name; //下载后文件名
                downloadElement.target = "_blank"; // 针对 ie模式 的浏览器
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                document.body.removeChild(downloadElement); //下载完成移除元素
                window.URL.revokeObjectURL(href); //释放掉blob对象
        }
}
export const formHeardData = {
        TabHeardSuccW: [
                {
                        title: "省份",
                        key: "province",
                        dataIndex: "province",
                        width: 50,
                        align: "center",
                },
                {
                        title: "城市",
                        dataIndex: "city",
                        key: "city",
                        width: 60,
                        align: "center",
                },
                {
                        title: "区县",
                        dataIndex: "area",
                        key: "county",
                        width: 70,
                        align: "center",
                },
                {
                        title: "网点资源名称",
                        dataIndex: "communityName",
                        key: "resourcesNmae",
                        width: 80,
                        align: "center",
                },
                {
                        title: "详细地址",
                        dataIndex: "communityAddress",
                        key: "communityAddress",
                        width: 120,
                        scopedSlots: { customRender: "communityAddress" },
                        align: "center",
                },
                {
                        title: "点位名称",
                        key: "communityName",
                        dataIndex: "deviceName",
                        ellipsis: true,
                        width: 80,
                        align: "center",
                },
                {
                        title: "点位ID",
                        dataIndex: "pointId",
                        key: "pointId",
                        width: 80,
                        align: "center",
                },
                {
                        title: "mac",
                        dataIndex: "mac",
                        key: "mac",
                        width: 80,
                        align: "center",
                },
                {
                        title: "移除本页",
                        dataIndex: "remove",
                        key: "remove",
                        width: 60,
                        className: "del",
                        align: "center",
                        scopedSlots: { customRender: "operation" },
                },
        ],
        TabHeardFailW: [
                {
                        title: "省份",
                        key: "province",
                        dataIndex: "province",
                        width: 50,
                        align: "center",
                },
                {
                        title: "城市",
                        dataIndex: "city",
                        key: "city",
                        width: 60,
                        align: "center",
                },
                {
                        title: "区县",
                        dataIndex: "area",
                        key: "county",
                        width: 70,
                        align: "center",
                },
                {
                        title: "网点资源名称",
                        dataIndex: "communityName",
                        key: "resourcesNmae",
                        width: 80,
                        align: "center",
                },
                {
                        title: "详细地址",
                        dataIndex: "communityAddress",
                        key: "communityAddress",
                        width: 120,
                        scopedSlots: { customRender: "communityAddress" },
                        align: "center",
                },
                {
                        title: "失败原因",
                        dataIndex: "failCause",
                        key: "failCause",
                        width: 200,
                        scopedSlots: { customRender: "communityAddress" },
                        align: "center",
                }
        ],
        succPoint: [
                {
                        title: "省份",
                        key: "province",
                        dataIndex: "province",
                        width: 50,
                        align: "center",
                },
                {
                        title: "城市",
                        dataIndex: "city",
                        key: "city",
                        width: 60,
                        align: "center",
                },
                {
                        title: "区县",
                        dataIndex: "area",
                        key: "county",
                        width: 70,
                        align: "center",
                },
                {
                        title: "网点资源名称",
                        dataIndex: "communityName",
                        key: "resourcesNmae",
                        width: 80,
                        align: "center",
                },
                {
                        title: "详细地址",
                        dataIndex: "communityAddress",
                        key: "communityAddress",
                        width: 120,
                        scopedSlots: { customRender: "communityAddress" },
                        align: "center",
                },
                {
                        title: "点位名称",
                        key: "deviceName",
                        dataIndex: "pointName",
                        ellipsis: true,
                        width: 80,
                        align: "center",
                },
                {
                        title: "点位ID",
                        dataIndex: "pointId",
                        key: "pointId",
                        width: 80,
                        align: "center",
                },
                {
                        title: "mac",
                        dataIndex: "mac",
                        key: "mac",
                        width: 80,
                        align: "center",
                },

        ],
        failPoint: [
                {
                        title: "省份",
                        key: "province",
                        dataIndex: "province",
                        width: 50,
                        align: "center",
                },
                {
                        title: "城市",
                        dataIndex: "city",
                        key: "city",
                        width: 60,
                        align: "center",
                },
                {
                        title: "区县",
                        dataIndex: "area",
                        key: "county",
                        width: 70,
                        align: "center",
                },
                {
                        title: "网点资源名称",
                        dataIndex: "communityName",
                        key: "resourcesNmae",
                        width: 80,
                        align: "center",
                },
                {
                        title: "详细地址",
                        dataIndex: "communityAddress",
                        key: "communityAddress",
                        width: 120,
                        scopedSlots: { customRender: "communityAddress" },
                        align: "center",
                },
                {
                        title: "点位名称",
                        key: "deviceName",
                        dataIndex: "pointName",
                        ellipsis: true,
                        width: 80,
                        align: "center",
                },
                {
                        title: "点位ID",
                        dataIndex: "pointId",
                        key: "pointId",
                        width: 80,
                        align: "center",
                },
                {
                        title: "mac",
                        dataIndex: "mac",
                        key: "mac",
                        width: 80,
                        align: "center",
                },
                {
                        title: "失败原因",
                        dataIndex: "failCause",
                        key: "failCause",
                        width: 80,
                        align: "center",
                },
        ],
} 